module.exports = __webpack_public_path__ + "static/media/Front Dysmate-Y report.3190182a.png";